import * as tslib_1 from "tslib";
import folderStore from 'owa-folders';
import getFolderData from 'owa-mail-actions/lib/getFolderData';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import strings from 'owa-strings/owa-mail-strings';
/**
 * Add dumpster to folder table
 * @param dumpsterFolderIdName - Distinguished folder name
 */
export default function loadDumpster(dumpsterFolderIdName) {
    var dumpsterFolderId = folderNameToId(dumpsterFolderIdName);
    var isDumpsterInFolderTable = folderStore.folderTable.has(dumpsterFolderId);
    if (!isDumpsterInFolderTable) {
        var dumpsterFolder = tslib_1.__assign({
            UnreadCount: 0,
            TotalCount: -1,
            FolderId: { Id: dumpsterFolderId },
            DistinguishedFolderId: dumpsterFolderIdName,
            DisplayName: strings.recoverableItemsFolderName,
        });
        folderStore.folderTable.set(dumpsterFolderId, dumpsterFolder);
        getFolderData(dumpsterFolderId);
    }
}
//# sourceMappingURL=loadDumpster.js.map